export default __webpack_public_path__ + "static/shop-new-arrivals-89b0d63a39e2e1c29a47f7c41a87b725.webp";